import React, { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
  ConfigurationMenuItem,
  MenuSelection,
} from "../../containers/configuration/configuration-menu-item";

export type ConfigurationMenuProps = {
  items: ConfigurationMenuItem[];
  selectedMenuItem?: MenuSelection;
  adminPageRoot?: string;
};

export const ConfigurationMenu: FC<ConfigurationMenuProps> = ({
  items,
  selectedMenuItem,
  adminPageRoot = "administrator",
}) => {
  const navigate = useNavigate();
  const { root, levelOne } = selectedMenuItem || {};
  const openKey = root ? root.path : undefined;
  const selectedKey = levelOne ? levelOne.path : root?.path;
  console.log({ selectedKey });
  const onOpenChange = (keys: React.Key[]) => {
    if (keys.length > 0) {
      navigate(`/${adminPageRoot}/${keys.find((key) => key !== openKey) as string}`);
    } else {
      navigate("/administrator");
    }
  };

  return (
    <Menu
      mode="inline"
      openKeys={openKey ? [openKey] : []}
      selectedKeys={selectedKey ? [selectedKey] : []}
      onOpenChange={onOpenChange}
    >
      {renderMenuItems(items, adminPageRoot)}
    </Menu>
  );
};

function renderMenuItems(items: ConfigurationMenuItem[], adminPageRoot: string) {
  return items.map((item) => {
    if (item.children && item.children.length > 0) {
      return (
        <Menu.SubMenu key={item.path} icon={item.icon} title={item.title}>
          {item.children.map((levelOneItem) => renderMenuItem(adminPageRoot, item, levelOneItem))}
        </Menu.SubMenu>
      );
    } else {
      return renderMenuItem(adminPageRoot, item);
    }
  });
}

function renderMenuItem(
  adminPageRoot: string,
  root: ConfigurationMenuItem,
  levelOne?: ConfigurationMenuItem
) {
  const to = levelOne
    ? `/${adminPageRoot}/${root.path}/${levelOne.path}`
    : `/${adminPageRoot}/${root.path}`;
  const { path, title } = levelOne || root;

  return (
    <Menu.Item icon={!levelOne && root.icon} key={path}>
      <Link to={to}>{title}</Link>
    </Menu.Item>
  );
}
